import apiInstance from "api";
import {
  getUserListingDataFailure,
  getUserListingDataStart,
  getUserListingDataSuccess,
  createUserSuccess,
  createUserStart,
  createUserFailure,
  assignDeviceStart,
  assignDeviceSuccess,
  assignDeviceFailure,
  removeDeviceStart,
  removeDeviceSuccess,
  removeDeviceFailure,
  storeTimezoneStart,
  storeTimezoneSuccess,
  storeTimezoneFailure,
  getTimezonesStart,
  getTimezonesSuccess,
  getTimezonesFailure,
} from "./reducers";

export const getUserListingData = (filters) => {
  return async (dispatch) => {
    try {
      dispatch(getUserListingDataStart());
      const response = await apiInstance.get("/admin/users", {
        params: {
          pageNumber: filters?.pageNumber || 1,
          pageSize: filters?.pageSize || 10,
          emailSearch: filters?.emailSearch || '',
          search: filters?.search || '',
          userType: filters?.userType,
          accountType: filters?.accountType,
        },
      });
      dispatch(getUserListingDataSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(getUserListingDataFailure(error.response.data));
      } else {
        dispatch(getUserListingDataFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const createUser = (data) => {
  return async (dispatch) => {
    try {
      dispatch(createUserStart());
      const response = await apiInstance.post("/admin/users", {
        ...data,
      });
      dispatch(createUserSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(createUserFailure(error.response.data));
      } else {
        dispatch(createUserFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const assignDevice = (data) => {
  return async (dispatch) => {
    try {
      dispatch(assignDeviceStart());
      const response = await apiInstance.post("/admin/users/assign/device", {
        ...data,
      });
      dispatch(assignDeviceSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(assignDeviceFailure(error.response.data));
      } else {
        dispatch(assignDeviceFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const removeDevice = (data) => {
  return async (dispatch) => {
    try {
      dispatch(removeDeviceStart());
      const response = await apiInstance.post("/admin/users/remove/device", {
        ...data,
      });
      dispatch(removeDeviceSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(removeDeviceFailure(error.response.data));
      } else {
        dispatch(removeDeviceFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const storeTimezoneAction = (data) => {
  return async (dispatch) => {
    try {
      dispatch(storeTimezoneStart());
      const response = await apiInstance.post("/timezones/user/add", {
        ...data,
      });
      dispatch(storeTimezoneSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(storeTimezoneFailure(error.response.data));
      } else {
        dispatch(storeTimezoneFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

export const getTimezonesAction = (data) => {
  return async (dispatch) => {
    try {
      dispatch(getTimezonesStart());
      const response = await apiInstance.get("/timezones", {
        ...data,
      });
      dispatch(getTimezonesSuccess(response.data.data));
    } catch (error) {
      if (!!error?.response?.data) {
        dispatch(getTimezonesFailure(error.response.data));
      } else {
        dispatch(getTimezonesFailure(error?.message || "Something went wrong"));
      }
    }
  };
};

